<template>
  <div class="sc-menu">
    <el-menu
      router
      :unique-opened="true"
      default-active="home"
      class="menu" :collapse="isCollapse" background-color="#324157" text-color="#bfcbd9">
      <el-menu-item index="home"><i class="iconfont icon-home"></i> <span>主页</span></el-menu-item>
      <el-submenu index="product.manage" v-permission="['brand.manage','category.manage','category.manage']">
        <template slot="title">
          <i class="iconfont icon-goods"></i>
          <span>商品管理</span>
        </template>
        <el-menu-item index="/brand/manage" v-permission="['brand.manage']">品牌管理</el-menu-item>
        <el-menu-item index="/category/manage" v-permission="['category.manage']">商品分类</el-menu-item>
        <el-menu-item index="/product/manage" v-permission="['product.manage']">商品管理</el-menu-item>
      </el-submenu>
      <el-submenu index="customer.manage" v-permission="['customer.manage','shop.manage']">
        <template slot="title">
          <i class="iconfont icon-people"></i>
          <span>客户管理</span>
        </template>
        <el-menu-item index="/customer/list" v-permission="['customer.manage']">客户一览</el-menu-item>
        <el-menu-item index="/shop/list" v-permission="['shop.manage']">店铺管理</el-menu-item>
      </el-submenu>
      <el-submenu index="order.manage" v-permission="['order.manage']">
        <template slot="title">
          <i class="iconfont icon-pay"></i>
          <span>订单管理</span>
        </template>
        <el-menu-item index="/order/list" v-permission="['order.manage']">订单一览</el-menu-item>
      </el-submenu>
      <el-submenu index="wxapp.home.manage" v-permission="['marketing.banner.manage','marketing.message.manage','marketing.category.manage','marketing.product.manage']">
        <template slot="title">
          <i class="iconfont icon-mobile"></i>
          <span>应用设置</span>
        </template>
        <el-menu-item index="/marketing/banner" v-permission="['marketing.banner.manage']">图片轮播</el-menu-item>
        <el-menu-item index="/marketing/message" v-permission="['marketing.message.manage']">文字轮播</el-menu-item>
        <!--el-menu-item index="/lottery/open">品牌推荐</el-menu-item-->
        <el-menu-item index="/marketing/category" v-permission="['marketing.category.manage']">分类推荐</el-menu-item>
        <el-menu-item index="/marketing/product" v-permission="['marketing.product.manage']">首页商品</el-menu-item>
      </el-submenu>
      <el-submenu index="vote.manage" v-permission="['vote.manage']">
        <template slot="title">
          <i class="iconfont icon-vote"></i>
          <span>投票管理</span>
        </template>
        <el-menu-item index="/vote/list" v-permission="['vote.find']">投票活动一览</el-menu-item>
        <el-menu-item index="/vote/findPlayer" v-permission="['vote.player.find']">选手一览</el-menu-item>
        <el-menu-item index="/vote/result" v-permission="['vote.result.find']">投票明细</el-menu-item>
        <el-menu-item index="/vote/order" v-permission="['vote.present.order']">送礼物明细</el-menu-item>
        <el-menu-item index="/vote/findPrize" v-permission="['vote.prize.find']">奖品管理</el-menu-item>
        <el-menu-item index="/vote/findPresent" v-permission="['vote.present.find']">礼物管理</el-menu-item>
        <!--el-menu-item index="/vote/findBanner" v-permission="['vote.banner.find']">图片广告管理</el-menu-item-->
      </el-submenu>
      <el-submenu index="lottery.manage" v-permission="['lottery.find','lottery.draw.find','lottery.prize.manage']">
        <template slot="title">
          <i class="iconfont icon-lottery"></i>
          <span>抽奖管理</span>
        </template>
        <el-menu-item index="/lottery/list" v-permission="['lottery.find']">抽奖活动一览</el-menu-item>
        <el-menu-item index="/lottery/draw" v-permission="['lottery.draw.find']">抽奖结果</el-menu-item>
        <el-menu-item index="/lottery/prize" v-permission="['lottery.prize.manage']">奖品管理</el-menu-item>
      </el-submenu>
      <el-submenu index="redenvelope.manage" v-permission="['redenvelope.find','redenvelope.open.find','redenvelope.category.manage']">
        <template slot="title">
          <i class="iconfont icon-redpacket"></i>
          <span>红包管理</span>
        </template>
        <el-menu-item index="/redenvelope/list" v-permission="['redenvelope.find']">红包一览</el-menu-item>
        <el-menu-item index="/redenvelope/open" v-permission="['redenvelope.open.find']">红包领取</el-menu-item>
        <el-menu-item index="/redenvelope/category" v-permission="['redenvelope.category.manage']">红包类型管理</el-menu-item>
      </el-submenu>
      <el-submenu index="system.manage" v-permission="['user.manage','role.manage','department.manage']">
        <template slot="title">
          <i class="iconfont icon-settings"></i>
          <span>系统管理</span>
        </template>
        <el-menu-item index="/user/manage" v-permission="['user.manage']">用户列表</el-menu-item>
        <el-menu-item index="/role/manage" v-permission="['role.manage']">角色管理</el-menu-item>
        <el-menu-item index="/department/manage" v-permission="['department.manage']">部门管理</el-menu-item>
      </el-submenu>
      <!-- el-submenu index="system.manage">
        <template slot="title">
          <i class="iconfont icon-settings"></i>
          <span >系统管理</span>
        </template>
        <el-menu-item index="status.view">系统状态</el-menu-item>
        <el-menu-item index="database.backup">数据库备份</el-menu-item>
      </el-submenu -->
    </el-menu>
  </div>
</template>

<script type="text/babel">
import permission from 'directive/permission/index.js'
export default {
  name: 'KyMenu',
  directives: { permission },
  props: {
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.sc-menu
  position: fixed
  z-index: 100
  background-color: #324157
  height: 100%
  overflow-y: auto
  overflow-x: hidden
  &::-webkit-scrollbar
    width: 5px
    height: 5px
  .el-menu:not(.el-menu--collapse)
    width: 200px
  .menu
    border-right: none
</style>



// WEBPACK FOOTER //
// src/components/KyMenu.vue